<template>
  <div>
    <div class="wrap orderList-wrap clearfix">
      <headerUserCenter v-if="isUnion" />
      <div class="fl">
        <user-left v-if="!isUnion"></user-left>
        <userLeftForBFD v-else></userLeftForBFD>
      </div>
      <div class="fl ml-8">
        <order-list
          :orderList="orderList"
          :unpaidAmount="unpaidAmount"
          :loading="loading"
          :historyLink="!isUnion ? historyLink : bfdHistoryLink"
        ></order-list>
        <div
          v-if="!loading"
          class="block mt-20 text-right"
        >
          <el-pagination
            v-if="orderList.length > 0"
            :current-page.sync="currPage"
            :page-size="pageInfo.pagesize"
            layout="prev, pager, next, jumper"
            :total="pageInfo.totalCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag, getQueryString } from '@utils';
import userLeft from './components/user';
import userLeftForBFD from './components/user/bfd';
import headerUserCenter from './components/bfdHeader';
import orderList from './components/orderList';

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
const cityId = getQueryString('city');
const union = getQueryString('union');
export default {
  name: 'OrderList',
  components: {
    userLeft,
    orderList,
    userLeftForBFD,
    headerUserCenter,
  },
  data() {
    return {
      tab: 0,
      currPage: 1,
      pagesize: 10,
      totalCount: 0,
      searchOrderNo: null, // 搜索中的订单编号
      isUnion: false, // 是否工会
      bfdHistoryLink: window.location.protocol + '//' + window.location.host.replace(/^www./,'') + `/user/order/goods?city=${cityId}&union=${union}`,
      historyLink: `/user/center/order/goods?city=${cityId}`,
    };
  },

  computed: {
    ...mapState('orderList', ['pageInfo', 'loading', 'unpaidAmount']),
    ...mapGetters('orderList', {
      orderList: 'getOrderList',
    }),
  },

  watch: {
    pageInfo(val) {
      const {currPage} = val;
      this.currPage = currPage;
    },
  },

  created() {
    if (unionFlag()) {
      this.isUnion = !this.isUnion;
      // console.log(this.apis);
    }
    this.initData();
  },

  methods: {
    ...mapActions('orderList', ['getOrderList']),
    ...mapMutations('orderList', ['setPageInfo']),
    initData() {
      this.fetchOrderList();
    },
    fetchOrderList() {
      const { tab } = this;
      const { currPage } = this;
      const orderNo = this.searchOrderNo;
      this.getOrderList({
        tab,
        orderNo,
        page: currPage,
      });
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.setPageInfo({
        ...this.pageInfo,
        currPage: val,
      });
      this.initData();
    },
  },
};
</script>

<style lang="less" scoped></style>
